export default __webpack_public_path__ + "static/media/56.217c7804.svg";